import { DEFAULT_POSITION, GEOLOCATION_OPTIONS } from './location.constants';
import { ILocationAccess, LocationAccess } from './location.types';

function requestPosition(options: PositionOptions): Promise<ILocationAccess> {
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      ({ coords }) =>
        resolve({
          access: LocationAccess.Granted,
          latitude: coords.latitude,
          longitude: coords.longitude,
        }),
      (error) =>
        resolve(
          error.code === error.PERMISSION_DENIED
            ? DEFAULT_POSITION
            : { ...DEFAULT_POSITION, access: LocationAccess.Unavailable }
        ),
      options
    );
  });
}

export async function getCurrentPosition(): Promise<ILocationAccess> {
  if (!navigator.geolocation) {
    return DEFAULT_POSITION;
  }

  const result = await requestPosition({ ...GEOLOCATION_OPTIONS, enableHighAccuracy: true });

  if (result.access !== LocationAccess.Unavailable) {
    return result;
  }

  return requestPosition({ ...GEOLOCATION_OPTIONS, enableHighAccuracy: false });
}

export const location = {
  requestPosition,
  getCurrentPosition,
};
